import React from 'react';
import './TimelineChart.css';

import TimelineView from '../TimeLineView/TimelineView';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Modal from 'react-modal';

import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';

import timelineSvg from '../../../assets/svgs/timeline.svg';

const contentStyles = {
  content: {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  }
};

class TimelineChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: false
    };
    this.onOpenModalHandler = this.onOpenModalHandler.bind(this);
    this.onCloseModalHandler = this.onCloseModalHandler.bind(this);
  }

  onOpenModalHandler(e) {
    this.setState({
      isModalOpen: true
    });
  }

  onCloseModalHandler(e) {
    this.setState({
      isModalOpen: false
    });
  }

  render() {
    return (
      <div className='timeline-widget'>
        <Card>
          <CardActionArea onClick={this.onOpenModalHandler}>
            <CardMedia
              component='img'
              alt='Timeline'
              height='200'
              image={timelineSvg}
              title='Timeline'
            />
            <CardContent
              className='align-center'
              onClick={this.onOpenModalHandler}
            >
              <Typography gutterBottom variant='h5' component='h2'>
                Timeline
              </Typography>
              <Typography variant='body2' color='textSecondary' component='p'>
                A quick timeline of important technologies
              </Typography>
            </CardContent>
          </CardActionArea>
          <CardActions className='align-center'>
            <Button
              size='small'
              color='primary'
              onClick={this.onOpenModalHandler}
            >
              Show Timeline
            </Button>
          </CardActions>
        </Card>
        <Modal
          closeTimeoutMS={300}
          isOpen={this.state.isModalOpen}
          onRequestClose={this.onCloseModalHandler}
          style={contentStyles}
        >
          <div className='close-modal-button-top'>
            <IconButton onClick={this.onCloseModalHandler}>
              <CloseIcon />
            </IconButton>
          </div>
          <div className='modal-content'>
            <h1>Timeline</h1>
            <TimelineView />
          </div>
          <div className='close-modal-button-bottom'>
            <Button
              size='large'
              variant='contained'
              color='primary'
              className='close-modal'
              onClick={this.onCloseModalHandler}
            >
              Close This
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}

export default TimelineChart;
